import React from 'react';

import {  MenuItem, ListItemIcon } from '@mui/material';
import { ExportFileType } from 'src/api/exportTypes';
import FileIcon from 'src/components/File/FileIcon';

interface Props {
  handleAction: (type: ExportFileType) => void;
  exportFileTypes?: ExportFileType[]
}

const allExportTypes = [
  ExportFileType.XLSX,
  ExportFileType.CSV,
]

const ExportTypesMenuItems: React.FC<Props> = ({ handleAction, exportFileTypes }: Props) => {
  const exportTypes = exportFileTypes ?? allExportTypes;
  return (
    <>
      <MenuItem
        id="xlsx"
        disabled={!exportTypes.includes(ExportFileType.XLSX)}
        onClick={() =>
          handleAction(ExportFileType.XLSX)
        }
      >
        <ListItemIcon>
          <FileIcon type="xlsx" />
        </ListItemIcon>
        Excel
      </MenuItem>
      <MenuItem
        id="csv"
        disabled={!exportTypes.includes(ExportFileType.CSV)}
        onClick={() =>
          handleAction(ExportFileType.CSV)
        }
      >
        <ListItemIcon>
          <FileIcon type="csv" />
        </ListItemIcon>
        CSV
      </MenuItem>
    </>
  );
};

export default ExportTypesMenuItems;
